import { Card, CardContent } from "@/components/atoms/card";
import { IItemDesc } from "@/services/types";
import RenderHtmlContentDescritpions from "./RenderHtmlContentDescritpions";

interface ComponentProps {
    itemData: IItemDesc;
    hasborder?: boolean | true;
    showDivider?: boolean;
}
export const ItemDescSection: React.FC<ComponentProps> = ({ itemData, hasborder, showDivider = false }) => {

    return (
        <>
            {itemData && <h3 className={"text-[#2A2A2A] text-2xl font-medium capitalize mb-6"}>{itemData.title}</h3>}
            {(hasborder && hasborder == true)
                ?
                itemData &&
                <Card className="mb-12 shadow-xl rounded-2xl ppx-2 py-6">
                    <CardContent className="p-4">
                        <RenderHtmlContentDescritpions
                            htmlContent={itemData.description}
                            className=" font-poppins">
                        </RenderHtmlContentDescritpions>
                    </CardContent>
                </Card>
                :
                itemData && (<div className={` text-base lg:text-lg font-light mb-6 ${hasborder ? 'rounded-2xl shadow-xl px-2 py-6' : ''}`}>
                   <hr className={`bg-[#92949F]  ${showDivider ? 'h-0.5 border-none' : 'h-0 border-none'}`} />
                    <RenderHtmlContentDescritpions
                        htmlContent={itemData.description}
                        className="font-poppins">
                    </RenderHtmlContentDescritpions>
                </div>)
            }
        </>


    );
};